import { render, staticRenderFns } from "./WaybillCreate.vue?vue&type=template&id=edd1420e&scoped=true&"
import script from "./WaybillCreate.vue?vue&type=script&lang=js&"
export * from "./WaybillCreate.vue?vue&type=script&lang=js&"
import style0 from "./WaybillCreate.vue?vue&type=style&index=0&id=edd1420e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd1420e",
  null
  
)

export default component.exports